import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;


 export const fetchUcrtList = createAsyncThunk(
    'ucrts/fetchUcrtList',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/ucrt/v1/list`, rejectWithValue)
 )

 export const createUpdateUcrt = createAsyncThunk(
   'ucrts/createUpdateUcrt',
   (arg, { rejectWithValue }) => DataService.post(arg, path+'client/ucrt/v1/edit-ucrt', rejectWithValue)
)

 export const downLoadUcrtReportDatewise = createAsyncThunk(
   'ucrts/downLoadUcrtReportDatewise',
   (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/ucrt/v1/datewise-report/${arg?.dateData}`, rejectWithValue)
)

export const downLoadUcrtReportInCSVDatewise = createAsyncThunk(
   'ucrts/downLoadUcrtReportInCSVDatewise',
   (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/ucrt/v1/datewise-report-csv/${arg?.dateData}`, rejectWithValue)
)

export const downLoadUcrtReport = createAsyncThunk(
   'ucrts/downLoadUcrtReport',
   (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/ucrt/v1/current-report`, rejectWithValue)
)

export const fetchUcrtAuditTrailList = createAsyncThunk(
   'ucrts/fetchUcrtAuditTrailList',
   (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/ucrt/v1/audit-trails', rejectWithValue)
)